import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'modules/store';

const selectState = (x: RootState) => x.managerActionsReducer;

export const selectManagerAction = createSelector(selectState, ({ managerAction }) => managerAction);
